import React from 'react';
import PropTypes from 'prop-types';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import { useTranslation } from 'react-i18next'

import Paper from '@material-ui/core/Paper';

import '../Sections/Sections.css'

import ReactHtmlParser from "react-html-parser";


function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <Typography
      component="div"
      role="tabpanel"
      hidden={value !== index}
      id={`scrollable-auto-tabpanel-${index}`}
      aria-labelledby={`scrollable-auto-tab-${index}`}
      {...other}
    >
      {value === index && <Box p={3}>{children}</Box>}
    </Typography>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function a11yProps(index) {
  return {
    id: `scrollable-auto-tab-${index}`,
    'aria-controls': `scrollable-auto-tabpanel-${index}`,
  };
}

export default function Cursos() {
  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const { t } = useTranslation();

  return (
    <div className="cursosbody">

        <div style={{color:"black"}} align="center"><h2>{t("menuServicios")}</h2></div>

      <AppBar position="static" color="default">
        <Tabs
          value={value}
          onChange={handleChange}
          indicatorColor="primary"
          textColor="primary"
          variant="scrollable"
          scrollButtons="auto"
          aria-label="scrollable auto tabs example">

          <Tab label={t('pilotoPrivado')} {...a11yProps(0)} />
          <Tab label={t('pilotoComercial')} {...a11yProps(1)} />
          <Tab label={t('pilotoComercial1raClase')} {...a11yProps(2)} />
          <Tab label={t('instructorVuelo')} {...a11yProps(3)} />
          <Tab label={t('alumnosExtranjeros')} {...a11yProps(4)} />
          <Tab label={t('vControlado')} {...a11yProps(5)} />
          <Tab label={t('vueloNocturno')} {...a11yProps(6)} />
          <Tab label={t('vueloInstrumentos')} {...a11yProps(7)} />
          <Tab label={t('simuladorVuelo')} {...a11yProps(8)} />
          <Tab label={t('avionesMultimotor')} {...a11yProps(9)} />
          <Tab label={t('vuelosBautismo')} {...a11yProps(10)} />
          <Tab label={t('OACI')} {...a11yProps(11)} />
        </Tabs>
      </AppBar>
      <Paper>
      <TabPanel value={value} index={0}>
        <div className='cursosTop'>
          <span className='cursosTexto'>{ReactHtmlParser(t('pilotoPrivadoTexto'))}  </span>
        </div>
       
      </TabPanel>
      <TabPanel value={value} index={1}>
        <div className='cursosTop'>
          <span className='cursosTexto'>{ReactHtmlParser(t('pilotoComercialTexto'))}  </span>
        </div>
      </TabPanel>
      <TabPanel value={value} index={2}>
        <div className='cursosTop'>
          <span className='cursosTexto'>{ReactHtmlParser(t('pilotoComercial1raClaseTexto'))}  </span>
        </div>
      </TabPanel>
      <TabPanel value={value} index={3}>
        <div className='cursosTop'>
          <span className='cursosTexto'>{ReactHtmlParser(t('instructorVueloTexto'))}  </span>
        </div>
      </TabPanel>
      <TabPanel value={value} index={4}>
        <div className='cursosTop'>
          <span className='cursosTexto'>{ReactHtmlParser(t('alumnosExtranjerosTexto'))}  </span>
        </div>
      </TabPanel>
      <TabPanel value={value} index={5}>
        <div className='cursosTop'>
          <span className='cursosTexto'>{ReactHtmlParser(t('vControladoTexto'))}  </span>
        </div>
      </TabPanel>
      <TabPanel value={value} index={6}>
        <div className='cursosTop'>
          <span className='cursosTexto'>{ReactHtmlParser(t('vueloNocturnoTexto'))}  </span>
        </div>
      </TabPanel>
      <TabPanel value={value} index={7}>
        <div className='cursosTop'>
          <span className='cursosTexto'>{ReactHtmlParser(t('vueloInstrumentosTexto'))}  </span>
        </div>
      </TabPanel>
      <TabPanel value={value} index={8}>
        <div className='cursosTop'>
          <span className='cursosTexto'>{ReactHtmlParser(t('simuladorVueloTexto'))}  </span>
        </div>
      </TabPanel>
      <TabPanel value={value} index={9}>
        <div className='cursosTop'>
          <span className='cursosTexto'>{ReactHtmlParser(t('avionesMultimotorTexto'))}  </span>
        </div>
      </TabPanel>
      <TabPanel value={value} index={10}>
        <div className='cursosTop'>
          <span className='cursosTexto'>{ReactHtmlParser(t('vuelosBautismoTexto'))}  </span>
        </div>
      </TabPanel>
      <TabPanel value={value} index={11}>
        <div className='cursosTop'>
          <span className='cursosTexto'>{ReactHtmlParser(t('OACITexto'))}  </span>
        </div>
      </TabPanel>
      </Paper>
    </div>
  );
}
